//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'test',
  props: {
    option: Object,
    component: Object
  },
  computed: {
    styleName: function styleName() {
      return {
        fontSize: this.fontSize,
        color: this.color
      };
    },
    color: function color() {
      return this.option.color || '#fff';
    },
    fontSize: function fontSize() {
      return (this.option.fontSize || 30) + 'px';
    }
  },
  methods: {}
};